import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgButton = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		r: 37.5
	})
});
export default SvgButton;
